const isDevelopment = process.env.NODE_ENV === 'development';

const config = {
    API_URL: isDevelopment ? 'http://localhost:3000' : 'https://connect.grupoidafa.cl',
};

export default config;
